// src/config/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore, collection } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Collection References
export const productsRef = collection(db, 'products');
export const categoriesRef = collection(db, 'categories');
export const ordersRef = collection(db, 'orders');
export const usersRef = collection(db, 'users');

// Schema Types
export interface FirebaseProduct {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
  brand: string;
  images: {
    url: string;
    alt: string;
    storageRef?: string;
  }[];
  stock: number;
  sku: string;
  featured: boolean;
  specifications: {
    [key: string]: string | number;
  };
  gsm?: number;
  size?: string;
  sheets?: number;
  finish?: string;
  rating?: number;
  reviewCount?: number;
  createdAt: Date;
  updatedAt: Date;
  slug: string;
}

export interface FirebaseCategory {
  id: string;
  name: string;
  description: string;
  slug: string;
  image?: {
    url: string;
    alt: string;
    storageRef?: string;
  };
  parent?: string;
  featured: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface FirebaseOrder {
  id: string;
  userId: string;
  items: {
    productId: string;
    quantity: number;
    price: number;
  }[];
  subtotal: number;
  tax: number;
  shipping: number;
  total: number;
  status: 'pending' | 'processing' | 'completed' | 'cancelled';
  paymentStatus: 'pending' | 'paid' | 'failed';
  paymentMethod: string;
  paymentDetails?: any;
  shippingAddress: {
    name: string;
    phone: string;
    email: string;
    address: string;
    city: string;
    country: string;
  };
  createdAt: Date;
  updatedAt: Date;
}

export interface FirebaseUser {
  id: string;
  email: string;
  name: string;
  phone?: string;
  role: 'customer' | 'admin';
  addresses?: {
    name: string;
    phone: string;
    address: string;
    city: string;
    country: string;
    isDefault: boolean;
  }[];
  createdAt: Date;
  updatedAt: Date;
}

export default app;